module.exports = __webpack_public_path__ + "fonts/Gilmer-Bold.81467a8.woff2?v=1744194310396";